<!--
  The landing page is not a list, a form or a details screen, and it uses the list-page
  pattern anyway. That is deliberate rather than lazy: this is the first screen an Operator
  sees after signing in, and it was the one screen in the product with a `text-5xl` centred
  `<h1>` and a gutter of its own on top of the shell's. Being the exception here costs more
  than the pattern's `loading` and `empty` inputs going unused, which is all it costs — both
  default to false and render nothing. The pattern's own note covers this: a screen with
  unusual demands puts unusual markup in a region, it does not stop using the pattern.

  The quick-action cards are `<a routerLink>` now, not `<div (click)>`. A div with a click
  handler is not focusable, has no role, and has no accessible name, so this screen's four
  primary actions could not be reached from a keyboard or announced by a screen reader at
  all. Links also restore what an Operator expects of navigation: middle-click, open in a
  new tab, and a status-bar preview of where it goes.

  The Quick Stats section is gone (#646). Its three cards — Active Rides, Available Drivers,
  Total Users — never had a data source: no binding, no facade call, nothing, and a hard-coded
  em dash in a `text-3xl font-bold` slot reads as "zero, or broken" rather than "not built".
  Deleting it was the product decision the ticket asked for; Quick Actions is the part of this
  screen that does something. Restoring the tiles means fetching real counts first.
-->
<elite-list-page
  testId="landing"
  [heading]="appName"
>
  <ng-template eliteListPageContent>
    <div class="flex flex-col gap-10">
      <section>
        <h2 class="text-foreground mb-6 text-xl font-semibold">Quick Actions</h2>
        <div class="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
          @for (action of visibleActions(); track action.route) {
            <a
              [routerLink]="action.route"
              class="bg-card text-card-foreground border-border hover:border-brand focus-visible:ring-ring group block cursor-pointer rounded-xl border p-6 text-center transition-all duration-300 hover:-translate-y-1 hover:shadow-xl focus-visible:ring-2 focus-visible:outline-none"
              [attr.data-testid]="'landing-action-' + action.key"
            >
              <div class="text-brand-strong mb-4 text-4xl transition-transform duration-300 group-hover:scale-110">
                <ng-icon [name]="action.icon" aria-hidden="true" />
              </div>
              <h3 class="text-foreground mb-3 text-lg font-semibold">{{ action.label }}</h3>
              <p class="text-muted-foreground leading-relaxed">{{ action.description }}</p>
            </a>
          }
        </div>
      </section>
    </div>
  </ng-template>
</elite-list-page>
